// eslint-disable-next-line
import { getKnowledgeBase, addKnowledgeFile } from '@/api/index';

export default {
  namespaced: true,
  state: { /* = data */
    categories: [],
    loading: {
      categories: false,
      addingCategory: false,
      addingFile: false,
    },
    userCanUpdate: false,
  },

  getters: { /* = Computed properties, perfects to filter data an execute some calculation */
  },


  actions: { /* = Methods */

    setUserCanUpdate({ commit }, userCanUpdate){
      commit('setUserCanUpdate', userCanUpdate);
    },

    loadCategories({ commit }) {
      commit('setLoading', { categories: true });
      getKnowledgeBase().then((categories) => {
        commit('setCategories', categories);
        
      }).finally(() => {
        commit('setLoading', { categories: false });
      });
    },

    async uploadKnowledgeFile({ state, dispatch }, {knowledge_category_id, file2Upload, name}) {
      if (file2Upload && file2Upload.file) {
        const file= await dispatch('uploadFile', {knowledge_category_id, type: 'file', file: file2Upload, name: name});
        return file;
      }
    },

    async uploadFile({ commit }, {knowledge_category_id, type, file, name}) {
      const formData = new FormData();
      formData.append('name', name);
      formData.append(type, file.file, file.name);
      return await addKnowledgeFile(knowledge_category_id, formData);
    },

  },

  mutations: { /* Mutations are responsible to change the state */
    setLoading(state, loading) {
      state.loading = { ...state.loading, ...loading };
    },

    setCategories(state, categories) {
      state.categories = categories;
    },
    
    addCategory(state, category) {
      state.categories = [...state.categories, category];
    },
    
    setUserCanUpdate(state, userCanUpdate){
      state.userCanUpdate = userCanUpdate;
    },

    removeCategory(state, index){
      state.categories.splice(index, 1);
    },

    removeFile(state, index){
      state.categories[index[0]].files.splice(index[1], 1);
    },

  },

};
